import React from "react";

const DIAS = [
  ["segunda", "Segunda"],
  ["terca", "Terça"],
  ["quarta", "Quarta"],
  ["quinta", "Quinta"],
  ["sexta", "Sexta"],
  ["sabado", "Sábado"],
  ["domingo", "Domingo"],
];

const TURNOS = [
  ["manha", "Manhã (6h–12h)"],
  ["tarde", "Tarde (12h–18h)"],
  ["noite", "Noite (18h–23h)"],
];

const _emptyHorario = () => ({
  segunda: [], terca: [], quarta: [], quinta: [],
  sexta: [], sabado: [], domingo: [],
});

export default function ProdutoFormAbaDisponibilidade({ data, update }) {
  const ativo = !!data.disponibilidade_horario;
  const h = data.disponibilidade_horario || _emptyHorario();

  const setAtivo = (v) => {
    update({ disponibilidade_horario: v ? _emptyHorario() : null });
  };

  const toggle = (dia, turno) => {
    const cur = h[dia] || [];
    const next = cur.includes(turno)
      ? cur.filter((t) => t !== turno)
      : [...cur, turno];
    update({ disponibilidade_horario: { ...h, [dia]: next } });
  };

  const marcarTodos = () => {
    const all = ["manha", "tarde", "noite"];
    const next = { ...h };
    DIAS.forEach(([d]) => { next[d] = all.slice(); });
    update({ disponibilidade_horario: next });
  };
  const marcarDiasUteis = () => {
    const next = _emptyHorario();
    ["segunda", "terca", "quarta", "quinta", "sexta"].forEach((d) => {
      next[d] = ["manha", "tarde", "noite"];
    });
    update({ disponibilidade_horario: next });
  };
  const limpar = () => update({ disponibilidade_horario: _emptyHorario() });

  return (
    <div className="space-y-3" data-testid="aba-disponibilidade">
      <div className="flex flex-col gap-2 text-sm">
        <label className="flex items-start gap-2 cursor-pointer">
          <input
            type="radio"
            name="disp-mode"
            checked={!ativo}
            onChange={() => setAtivo(false)}
            data-testid="disp-sempre"
          />
          <div>
            <span className="font-medium">Disponível sempre</span>
            <p className="text-xs text-[var(--text-secondary)]">
              O produto aparece no cardápio o tempo todo (padrão).
            </p>
          </div>
        </label>
        <label className="flex items-start gap-2 cursor-pointer">
          <input
            type="radio"
            name="disp-mode"
            checked={ativo}
            onChange={() => setAtivo(true)}
            data-testid="disp-restrito"
          />
          <div>
            <span className="font-medium">Definir dias e horários específicos</span>
            <p className="text-xs text-[var(--text-secondary)]">
              Útil para almoço, café da manhã ou produtos sazonais.
            </p>
          </div>
        </label>
      </div>

      {ativo && (
        <>
          <div className="flex flex-wrap gap-1.5">
            <button type="button" onClick={marcarDiasUteis}
              className="text-xs px-2.5 py-1 border border-[var(--border)] rounded hover:bg-[var(--bg-secondary)]">
              Marcar dias úteis
            </button>
            <button type="button" onClick={marcarTodos}
              className="text-xs px-2.5 py-1 border border-[var(--border)] rounded hover:bg-[var(--bg-secondary)]">
              Marcar todos
            </button>
            <button type="button" onClick={limpar}
              className="text-xs px-2.5 py-1 border border-[var(--border)] rounded hover:bg-[var(--bg-secondary)] text-red-600">
              Limpar
            </button>
          </div>
          <div className="overflow-x-auto -mx-4 px-4">
            <table className="w-full text-xs border-collapse">
              <thead>
                <tr>
                  <th className="text-left py-2 font-semibold">Dia</th>
                  {TURNOS.map(([k, l]) => (
                    <th key={k} className="text-center py-2 font-medium px-1">
                      {l}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {DIAS.map(([dKey, dLabel]) => {
                  const turnosDia = h[dKey] || [];
                  const vazio = turnosDia.length === 0;
                  return (
                    <tr key={dKey} className="border-t border-[var(--border)]">
                      <td className={`py-1.5 ${vazio ? "text-red-600 italic" : ""}`}>
                        {dLabel}{vazio && " (indisponível)"}
                      </td>
                      {TURNOS.map(([tKey]) => (
                        <td key={tKey} className="text-center">
                          <input
                            type="checkbox"
                            checked={turnosDia.includes(tKey)}
                            onChange={() => toggle(dKey, tKey)}
                            data-testid={`disp-${dKey}-${tKey}`}
                          />
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <p className="text-[11px] text-[var(--text-secondary)] bg-amber-50 border border-amber-200 rounded p-2">
            Dia sem nenhum turno marcado = produto indisponível naquele dia.
          </p>
        </>
      )}
    </div>
  );
}
